const P2Section3 = () => {
    return ( 
        <div className="P2Section3">

            <h1> How does it work? </h1>

            <p> An IDP is a tool for self-reflection that allows you to both identify you <br/> <em>strongest skills and interests</em>, and assess your <em>most important values.</em></p>

        </div>
     );
}
 
export default P2Section3;